<div class="main_body">
  <app-page-header
    title="ユーザー"
    i18n-title="@@adminSection.userList.title.list"
    subtitle="ユーザー情報の閲覧・編集・停止・再開の設定を行います。"
    i18n-subtitle="@@adminSection.userList.message.description"
    icon="user"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- Left: Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder">{{ i18n.filter.namePlaceholder }}</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="i18n.filter.namePlaceholder"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSection.userList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>

          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="createUser()"
              matTooltip="ユーザー登録"
              aria-label="ユーザー登録"
              i18n-matTooltip="@@adminSection.userList.tooltip.createUser"
              i18n-aria-label="@@adminSection.userList.ariaLabel.createUser"
            >
              <mat-icon>person_add</mat-icon>
            </button>
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSection.userList.tooltip.refresh"
              i18n-aria-label="@@adminSection.userList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="8" />
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status"
              matSortDirection="desc">

              <!-- Name Column (home-user-list の identity 列に統一: 左固定なし) -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-column" i18n="@@adminSection.userList.label.codeName"> CODE/氏名 </th>
                <td mat-cell *matCellDef="let row" class="name-column"> {{row.name}} </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSection.userList.label.status"> ステータス </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.status == 'OPEN') {
                    <span class="status-badge status-badge--active">{{accountStatus[row.status]}}</span>
                  } @else {
                    <span class="status-badge status-badge--inactive">{{accountStatus[row.status]}}</span>
                  }
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@adminSection.userList.label.createdDate"> アカウント作成日 </th>
                <td mat-cell *matCellDef="let row" class="table-cell-date"> {{row.createdDate}} </td>
              </ng-container>

              <!-- Contributors Column -->
              <ng-container matColumnDef="contributors">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 300px;" i18n="@@adminSection.userList.label.contributors"> 閲覧可能多職種スタッフ </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.contributors && row.contributors.length > 0) {
                    <div>
                      @for (contributor of row.contributors; track contributor) {
                        <div>
                          <div [id]="row.userId+'+'+contributor.userId" class="container">
                            <div class="contributor-box">
                              <div class="remove-button" (click)="removeContributorAccess(row.userId, contributor.userId)">✕</div>
                              <div> &nbsp;{{ contributor.lastName }} {{ contributor.firstName }} ({{ common.getJobTitle( contributor.jobTitleCode ) }})</div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (row.links && row.links.length > 0) {
                    @for (link of row.links; track link) {
                      <div>
                        <div [id]="link.key" class="container">
                          <div class="link-box">
                            <div class="remove-button" (click)="disableLinkDocument(link.key)">✕</div>
                            <div i18n="@@adminSection.userList.label.inviting"> &nbsp; 招待中 : {{ link.email }} ({{ common.getJobTitle(link.jobTitleCode) }})</div>
                          </div>
                        </div>
                      </div>
                    }
                  }
                  <div class="container">
                    <div class="contributor-add-box" (click)="openContributorPicker(row.userId, row.name)" i18n="@@adminSection.userList.button.addContributor">
                      ＋ 追加
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Actions Column (hover reveal - 2 icons side by side) -->
              <ng-container matColumnDef="actions" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
                <td mat-cell *matCellDef="let row" class="actions-cell">
                  <div class="staff-actions-group">
                    <!-- ユーザー情報 -->
                    <button
                      mat-icon-button
                      class="staff-action-button"
                      (click)="openUserDetailsDialog(row.userId)"
                      matTooltip="ユーザー情報"
                      i18n-matTooltip="@@adminSection.userList.tooltip.userInfo"
                      aria-label="ユーザー情報"
                      i18n-aria-label="@@adminSection.userList.ariaLabel.userInfo"
                    >
                      <mat-icon class="staff-action-icon">assignment_ind</mat-icon>
                    </button>
                    <!-- アカウント停止/再開 -->
                    @if (row.status === 'OPEN') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--danger"
                        (click)="openUserActivationDialog(row.userId)"
                        matTooltip="アカウント停止"
                        i18n-matTooltip="@@adminSection.userList.tooltip.deactivate"
                        aria-label="アカウント停止"
                        i18n-aria-label="@@adminSection.userList.ariaLabel.deactivate"
                      >
                        <mat-icon class="staff-action-icon">person_off</mat-icon>
                      </button>
                    }
                    @if (row.status === 'CLOSE') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--success"
                        (click)="openUserActivationDialog(row.userId)"
                        matTooltip="アカウント再開"
                        i18n-matTooltip="@@adminSection.userList.tooltip.reactivate"
                        aria-label="アカウント再開"
                        i18n-aria-label="@@adminSection.userList.ariaLabel.reactivate"
                      >
                        <mat-icon class="staff-action-icon">how_to_reg</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [class.row-inactive]="row.anonymous"
                [class.row-closed]="row.status === 'CLOSE'"></tr>
            </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
